import {deliveryTheme} from './theme'
import { CSSProperties } from '../../theme/css'

const wrapVar = <Value extends string | undefined>(token: string, hex: Value) => {
  // Здесь нам нужна именно ссылочная строка, чтобы ее правильно обрабатывала линария И можно было впихнуть доп свойства
  // eslint-disable-next-line no-new-wrappers
  const result: Var<Value> = new String(`var(${token},${hex || ''})`) as Var<Value>
  result.token = token
  result.hex = hex
  return result
}
// fixme костыли. CSSProperties нужен чтобы линария не ругалась на интерполяцию, инстанс String для ссылочного значения, остальное - публичный интерфейс
// придумывать как сделать некостыльно имеет смысл после апгрейда линарии
export type Var<Value extends string | undefined = string> = CSSProperties & String & {token: string; hex: Value}

type ThemeVars<T> = {
  [Key in keyof T]-?: T[Key] extends string | number | undefined
    ? Var<Extract<T[Key], string | undefined>>
    : T[Key] extends object
      ? ThemeVars<T[Key]>
      : T[Key]
}
const toFigmaKeys = ({
  colorScheme: {bgMinor, bgInvert, ...colorScheme},
  ...themeRest
}: ThemeVars<typeof deliveryTheme>) => ({
  ...themeRest,
  default: {
    day: {
      ...colorScheme,
      backgroundMinor: bgMinor,
      backgroundInvert: bgInvert,
    },
  },
})

const toVars = <T>(sourceTheme: T, prefix = ''): ThemeVars<T> => {
  const entries = Object.entries(sourceTheme as Record<string, unknown>).map(
    ([key, value]: [string, unknown]) => {
      switch (typeof value) {
        case 'string':
          return [key, wrapVar(`--${prefix}${key}`, value)] as const
        case 'object':
          return value === null
            ? ([key, value] as const)
            : ([key, toVars(value, `${prefix}${key}-`)] as const)
        case 'number':
          return [key, wrapVar(`--${prefix}${key}`, `${value}px`)] as const
        default:
          return [key, value] as const
      }
    },
  )

  return Object.fromEntries(entries) as ThemeVars<T>
}

const cssTheme = toFigmaKeys(toVars(deliveryTheme))

export default cssTheme
